import ReportRraRequestSuccessScreen from '@/screens/ReportDetail/components/rra/ReportRraRequestSuccessScreen';

export default ReportRraRequestSuccessScreen;
